import styled from "styled-components";

import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  width: 100%;
  height: 100%;

  margin: auto;
  background-color: ${COLORS.BLACK_50};

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 8px;
`;

export const ExitButton = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
`;

export const Content = styled.div`
  padding: 50px 60px 0;

  max-height: 100%;
  overflow-y: auto;
  overflow-y: overlay;

  align-self: center;

  position: relative;

  /* Padding bottom hack for EDGE */
  &:after {
    content: "";
    display: block;
    height: 60px;
    width: 100%;
  }
`;

export const PaperContainer = styled.div`
  display: flex;
  height: 100%;
`;
